<form [formGroup]="formGroup">
  @for (p of prefFields?.controls; track p; let i = $index) {
    <EXP__glxy-wrap class="preference">
    <mat-checkbox [checked]="p.value" [disabled]="!allowEditing" (click)="toggleSelection(i)">
      @if (data[i]?.categoryName.length > 140) {
        <span [glxyTooltip]="data[i]?.categoryName">
          {{ data[i]?.categoryName | truncate: 140 }}
        </span>
      } @else {
        {{ data[i]?.categoryName }}
      }
    </mat-checkbox>
  </EXP__glxy-wrap>
}
</form>
